import {ChangeDetectionStrategy, Component, Inject, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';

require('./bringoz-packages-items-display-list.scss');
@Component({
  standalone: false,
  selector: 'app-bringoz-packages-items-display-list',
  templateUrl: './bringoz-packages-items-display-list.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class BringozPackagesItemsDisplayListComponent implements OnInit, OnChanges {
  @Input() items: any;
  @Input() isDisplayIds: boolean;

  public itemsDisplay: string[];
  public sitePackageItemsMap: any;

  constructor(@Inject('splitService') private splitService) {
  }

  ngOnInit() {
    this.sitePackageItemsMap = this.splitService.getSitePackageItemsMap();
    if (this.items) {
      this.initItemsData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.items && !changes.items.isFirstChange()) {
      if (this.items) {
        this.initItemsData();
      }
    }
  }

  private initItemsData() {
    if (this.isDisplayIds) {
      this.itemsDisplay = this.items.filter((item) => item.id)
        .map((item) => item.id)
    } else {
      this.itemsDisplay = this.items.map((item) => {
        if (item.size) {
          return this.sitePackageItemsMap[item.size]?.name;
        } else {
          return this.sitePackageItemsMap[item.type]?.name;
        }
      })

    }

  }

}
